export type AIAssistantMessage = {
  id: string;
  content: string;
  isOutgoing: boolean;
  suggestions?: string[];
};

export type AIUserPerformanceDialogState = {
  entityId: string;
  userId: string;
};

export enum AIAgentType {
  help = "help",
  myTasks = "my_tasks",
  board = "board",
}

export type AIAgent =
  | {
      agent: AIAgentType.help;
    }
  | {
      agent: AIAgentType.myTasks;
      entity_id: string;
      user_id: string;
    }
  | { agent: AIAgentType.board; entity_id: string; board_id: string };

export type AIResponseStream = {
  chunk: string;
  session_id: string;
};

export type AIQuota = {
  remaining: number;
};

export type PhxResponse<T> = {
  status: string;
  response: T;
};
